import { onApplicationMenu, onTopLevelRoutes } from 'core';
import Router from './components/Router';

onTopLevelRoutes(() => ({
  path: '/store',
  secure: true,
  component: Router,
}));

onApplicationMenu(() => ({
  group: 'stock',
  label: 'stores',
  icon: 'factory',
  to: '/store',
}));
